module.exports = __webpack_public_path__ + "static/media/avaira.805659a1.png";